export enum ROUTE_SOURCES {
  REGISTER = 'register',
  LOGIN = 'login',
  FORGOT_PASSWORD = 'forgot-password',
  RESET_PASSWORD = 'reset-password',
  DASHBOARD = 'dashboard',
  CONVERSATION = 'dashboard/conversation',
  SETTINGS = 'settings',
  CONNECTORS = 'connectors',
  TERMS = 'terms', // Pagina Termini e Condizioni (pubblica)
  /** Hub editoriale pubblico (SEO / blog homepage) — EN */
  BLOG = 'blog',
  /** Blog in italiano: path completo `/${BLOG_IT}` (stesso pattern i18n delle landing con prefisso locale). */
  BLOG_IT = 'it/blog',
  PRIVACY = 'privacy', // Pagina Privacy Policy (pubblica)
  DATA_DELETION = 'data-deletion', // Pagina Istruzioni Eliminazione Dati (pubblica)
  CREATE_FORMULA = 'create-custom-formula',
  EDIT_FORMULA = 'edit-custom-formula',
  ACCOUNTS = 'accounts',
  METRICS = 'metrics',
  GOOGLE_ADS_AUTH_CALLBACK = 'google-ads/auth/callback',
  GOOGLE_ANALYTICS_AUTH_CALLBACK = 'google-analytics/auth/callback',
  GOOGLE_SEARCH_CONSOLE_AUTH_CALLBACK = 'google-search-console/auth/callback',
  SHOPIFY_AUTH_CALLBACK = 'shopify/auth/callback',
  FACEBOOK_AUTH_CALLBACK = 'facebook/auth/callback',
  CUSTOM_REPORT = 'custom-report',
  SUPPORT = 'support',
  TEAM_MANAGEMENT = 'team',
  ACCEPT_INVITE = 'accept-invite',
  INVENTORY = 'inventory',
  INVENTORY_RESTOCKED = 'inventory/restocked',
  PRODUCTS_ANALYSIS = 'products-analysis',
  CATEGORY_ANALYSIS = 'category-analysis',
  BUNDLES = 'bundles',
  RETENTION = 'retention',
  KPI = 'kpi',
  FINANCE = 'finance',
  LANDING_ADV = 'landing-adv',
  LANDING_ADV_THANK_YOU = 'landing-adv/thank-you',
  /** Lab: prompt deck da incollare in un generatore esterno (nessun brand in UI) */
  AI_DECK_STUDIO = 'studio/ai-deck',
  BETA = 'beta',
}
